<template>
  <div class="cure_info">
    <div class="flex_item">
      <a
          :class="`btn ${device === 1 ? 'blue' : 'gray'} btn_basics pointer no-drag`"
          @click="handleDeviceClick(1)"
      >
        rebless
      </a>
      <a
          :class="`btn ${device === 2 ? 'blue' : 'gray'} btn_basics pointer no-drag`"
          @click="handleDeviceClick(2)"
      >
        rebless Pro
      </a>
    </div>
    <ul class="menu">
      <li
          v-show="!check"
          class="pointer no-drag"
          style="position: relative; padding-right: 28px;"
          @click="changeCategory(null)"
      >
        <a :class="selectedCategoryStatus === null ?'active':''">
          {{$t('rehabilitation.rehabilitation')}} ({{ $t('rehabilitation.clinician') }})
        </a>
        <div class="open">
          <svg
              v-if="open" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              @click="handleOpenClick"
          >
            <path d="M18.7047 8.29027C18.3143 7.89991 17.6838 7.89991 17.2934 8.29027L11.9987 13.5852L6.70401 8.29027C6.31366 7.89991 5.68311 7.89991 5.29276 8.29027C4.90241 8.68064 4.90241 9.31123 5.29276 9.7016L11.2981 15.7072C11.4983 15.9074 11.7485 15.9975 12.0087 15.9975C12.269 15.9975 12.5192 15.8974 12.7194 15.7072L18.7247 9.7016C19.095 9.32124 19.095 8.68064 18.7047 8.29027Z" fill="#201F1E"/>
          </svg>
          <svg
              v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              @click="handleOpenClick"
          >
            <path d="M18.7025 14.2959L12.7025 8.29027C12.3125 7.89991 11.6825 7.89991 11.2925 8.29027L5.2925 14.2959C4.9025 14.6863 4.9025 15.3169 5.2925 15.7072C5.4925 15.9074 5.7425 15.9975 6.0025 15.9975C6.2625 15.9975 6.5125 15.8974 6.7125 15.7072L12.0025 10.4123L17.2925 15.7072C17.4925 15.9074 17.7425 15.9975 18.0025 15.9975C18.2625 15.9975 18.5125 15.8974 18.7125 15.7072C19.0925 15.3269 19.0925 14.6863 18.7025 14.2959Z" fill="#201F1E"/>
          </svg>
        </div>
      </li>
      <ol :style="open ? '' : 'display:none'">
        <li
            class="pointer no-drag"
            @click="changeCategory(0)"
        >
          <a :class="selectedCategoryStatus === 0?'active':''">
            {{ $t('status.assigned') }}
          </a>
        </li>
        <li
            class="pointer no-drag"
            @click="changeCategory(1)"
        >
          <a :class="selectedCategoryStatus === 1 ?'active':''">
            {{ $t('status.terminated') }}
          </a>
        </li>
        <li
            class="pointer no-drag"
            @click="changeCategory(2)"
        >
          <a :class="selectedCategoryStatus === 2 ?'active':''">
            {{ $t('status.accomplished_manual') }}
          </a>
        </li>
        <li
            class="pointer no-drag"
            @click="changeCategory(3)"
        >
          <a :class="selectedCategoryStatus === 3 ?'active':''">
            {{ $t('status.accomplished_auto') }}
          </a>
        </li>
        <li
            class="pointer no-drag"
            @click="changeCategory(4)"
        >
          <a :class="selectedCategoryStatus === 4?'active':''">
            {{ $t('status.on_progress') }}
          </a>
        </li>
        <li
            class="pointer no-drag"
            @click="changeCategory(5)"
        >
          <a :class="selectedCategoryStatus === 5 ?'active':''">
            {{ $t('status.past_due') }}
          </a>
        </li>
      </ol>
      <li
          class="pointer no-drag"
          @click="changeCategory(6)"
      >
        <a :class="selectedCategoryStatus === 6 ?'active':''">
          {{$t('rehabilitation.rehabilitation')}} ({{ $t('rehabilitation.patient') }})
        </a>
      </li>
    </ul>
<!--    <ul class="mt20">-->
<!--      <li>-->
<!--        <span class="active pdb10 display_i_b">-->
<!--          {{ selectedCategoryStatus !== 6 ? $t('rehabilitation.date-range-due') : this.$t('rehabilitation.duration') + this.$t('rehabilitation.date-range') }}-->
<!--            <a @click="refresh" class="pointer" v-tooltip="this.$t('status.reset')">-->
<!--                <img-->
<!--                    src="../../../../../../public/images/refresh.png"-->
<!--                    style="width: 17px; margin-left:2px;"-->
<!--                    alt=""-->
<!--                >-->
<!--            </a>-->
<!--        </span>-->
<!--        <DateRangeInput :item="item"/>-->
<!--      </li>-->
<!--    </ul>-->
    <ul class="mt20">
      <li>
        <span class="active pdb10 display_i_b">
          {{ $t('patients.search_name') }}
        </span>
        <v-select
            :class="`rehabSelect ${open ? 'open' : 'close'}`"
            v-model="searchKeyword"
            :options="patientList"
            :get-option-label="option => option.trans ? this.$t(option.trans) : option.title"
        >
          <template
              v-slot:option="option"
          >
            <span class="option">
              {{ option.trans ? $t(option.trans) : option.title }}
            </span>
          </template>
          <span slot="no-options">{{ $t('patients.no_search_data') }}</span>
        </v-select>
      </li>
    </ul>
  </div>
</template>

<script>
import DateRangeInput from "../../../../Table/types/calender/date-rangeInput"

export default {
  components: {
    DateRangeInput,
  },
  props: [
    'selectedCategoryStatus',
    'device',
    'check',
  ],
  data() {
    return {
      // item: {
      //   values: {
      //     start: null, //new Date(new Date().setMonth(new Date().getMonth() - 1)),
      //     end: null, //new Date()
      //   },
      //   componentOptions: {
      //     popoverDirection: 'top',
      //     popoverVisibility: 'focus'
      //   },
      //   class: 'date-filtering-input'
      // },
      open: false,
      patientList: [],
      searchKeyword: {},
    }
  },
  created() {
    this.unsubscribe = this.$store.subscribe((_mutation, state) => {
      if (this.patientList !== state.patientList) {
        let refinedPatientList = [];
        const patientList = state.patientList.filter(
            item => item.check === true
                && item.patientEmail !== localStorage.getItem('userEmail')
        );

        for (let i = 0; i < patientList.length; i++) {
          const item = {};
          item["no"] = i + 1;
          item["key"] = i + 1;
          item["title"] = patientList[i].patientInfo.patientInfoName;
          item["seqMedicalRelation"] = patientList[i].patientInfo.seqMedicalRelation;
          refinedPatientList.push(item);
        }

        this.patientList = refinedPatientList;
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  methods: {
    changeCategory(status) {
      this.$emit('selectedCategory', status);
    },
    // refresh() {
    //   this.item.values = {
    //     start: null, //new Date(new Date().setMonth(new Date().getMonth() - 1)),
    //     end: null, //new Date()
    //   };
    // },
    handleOpenClick() {
      this.open = !this.open;
    },
    handleDeviceClick(device) {
      this.$emit('onDeviceChange', device);
    },
  },
  watch: {
    searchKeyword: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue?.seqMedicalRelation !== oldValue?.seqMedicalRelation) {
          this.$emit('selectedName', newValue);
        }
      },
    }
  }
}
</script>
<style lang="scss" scoped>
.cure_info {
  max-width: 200px;
  min-width: 170px;
  margin: 0 20px 0.5rem 0.5rem;

  .flex_item {
    display: flex;
    padding-bottom: 10px;

    a {
      overflow: hidden;
      word-break: break-all;
    }
  }

  ul:nth-child(3) {
    li {
      padding: 0;
    }
  }

  ul:nth-child(4) {
    li {
      padding: 0;
    }
  }

  ul {
    li {
      padding: 15px;
      border-bottom: 1px solid var(--white);

      a.active {
        color: var(--blue70);
        font-weight: bold;
      }

      span.active {
        color: var(--blue70);
        font-weight: bold;
      }

      .patient_name_search {
        border-radius: 5px;
        height: 40px;
        width: 100%;
        //background: #fff url('/images/ic/comm/ic-search.svg') 10px 10px no-repeat;
        //text-indent: 50px;
        cursor: Auto;
        border: 1px solid var(--grey20);
      }

      .patient_name_search:focus {
        border: 1px solid var(--blue70);
      }

      .patient_name_search:disabled {
        background-color: var(--grey10) !important;
      }
    }
  }

  .menu {
    background-color: #FFFFFF !important;

    li {
      background-color: var(--grey10);
      max-height: 55px;

      .open {
        position: absolute;
        right: 5px;
        top: 9px;
      }
    }

    ol {
      margin-left: 1rem;

      li {
        background-color: var(--grey10);
      }
    }
  }
}
</style>
